import { toBaseLineItem } from "./base-line-item.js";
const toRegularOrderLineItem = (orderLineItem, intl, options = {}) => {
  return {
    ...toBaseLineItem(orderLineItem, intl, options),
    type: "REGULAR",
    isSubscription: orderLineItem.isSubscription,
    subscriptionDetails: orderLineItem.subscriptionDetails ? {
      deliveryInterval: orderLineItem.subscriptionDetails.deliveryInterval
    } : void 0
  };
};
export {
  toRegularOrderLineItem
};
//# sourceMappingURL=regular-line-item.js.map
